module.exports = __webpack_public_path__ + "img/hk.b51b06be.png";